import { Logger } from '@/definitions';

const isDevelopment = process.env.NODE_ENV === 'development';

const logger: Logger = {
  info: (message: string, ...args: unknown[]): void => {
    if (isDevelopment) {
      console.info(`[INFO]: ${message}`, ...args);
    }
  },
  warn: (message: string, ...args: unknown[]): void => {
    if (isDevelopment) {
      console.warn(`[WARN]: ${message}`, ...args);
    }
  },
  error: (message: string, ...args: unknown[]): void => {
    console.error(`[ERROR]: ${message}`, ...args);
  },
  debug: (message: string, ...args: unknown[]): void => {
    if (isDevelopment) {
      console.debug(`[DEBUG]: ${message}`, ...args);
    }
  },
};

export default logger;
